var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.active
    ? _c(
        "div",
        {
          staticClass:
            "fixed flex items-center justify-center w-full h-full inset-0",
          style: { background: _vm.brandLightest },
          attrs: { id: "error", "data-test": "error" }
        },
        [
          _c("div", { staticClass: "p-6 text-center" }, [
            _vm.title
              ? _c(
                  "h3",
                  {
                    staticClass: "text-2xl mb-5",
                    style: { font: _vm.headline, color: _vm.contrast },
                    attrs: { "data-test": "error--title" }
                  },
                  [_vm._v(_vm._s(_vm.$t(_vm.title)))]
                )
              : _vm._e(),
            _vm.message
              ? _c(
                  "p",
                  {
                    staticClass: "max-w-xl mb-5",
                    style: { color: _vm.contrast },
                    attrs: { "data-test": "error--message" }
                  },
                  [_vm._v(_vm._s(_vm.$t(_vm.message)))]
                )
              : _vm._e(),
            _vm.retry
              ? _c(
                  "button",
                  {
                    staticClass: "px-5 py-2 rounded-sm",
                    style: Object.assign(
                      {},
                      { color: _vm.alt, background: _vm.brandDark },
                      _vm.headline
                    ),
                    attrs: { "data-test": "error--retry" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.retryAction($event)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("PLAYER.RETRY")))]
                )
              : _vm._e()
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }